const firebaseConfig = {
    apiKey: "AIzaSyBLtCNRlHNOei03jt3f7wz-mBm_lAwCYXY",
    authDomain: "doctors-portal-a3956.firebaseapp.com",
    projectId: "doctors-portal-a3956",
    storageBucket: "doctors-portal-a3956.appspot.com",
    messagingSenderId: "1005344265502",
    appId: "1:1005344265502:web:a1844baf510ed14e44250f"
};
export default firebaseConfig;